import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ArrowUpRight, ChevronDown, Menu, X } from "lucide-react";
import { NAV_LINKS, COMPANY_MENU, COMPANY } from "../mock";

function Logo({ dark }) {
  return (
    <Link to="/" className="flex items-center gap-3 group">
      <span className="grid h-10 w-10 place-items-center border-2 border-[#c3e63c] shrink-0">
        <span className="h-4.5 w-4.5 h-[18px] w-[18px] bg-[#c3e63c] transition-transform duration-500 group-hover:rotate-45" />
      </span>
      <span className="font-display text-base md:text-2xl font-bold tracking-tight leading-none uppercase">
        <span className={dark ? "text-[#0a0a0a]" : "text-white"}>Garry Industries</span>
        <span className="text-[#c3e63c]"> - </span>
        <span className={dark ? "text-[#0a0a0a]" : "text-white"}>Railway Machines</span>
      </span>
    </Link>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [compOpen, setCompOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); setCompOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex h-16 md:h-[74px] items-center justify-between">
          <Logo dark={false} />

          <nav className="hidden xl:flex items-center gap-6">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `eyebrow link-line transition-colors ${isActive ? "text-[#c3e63c]" : "text-neutral-300 hover:text-white"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="relative" onMouseEnter={() => setCompOpen(true)} onMouseLeave={() => setCompOpen(false)}>
              <button className="eyebrow flex items-center gap-1 text-neutral-300 hover:text-white transition-colors">
                Company <ChevronDown size={13} className={`transition-transform ${compOpen ? "rotate-180" : ""}`} />
              </button>
              <div className={`absolute right-0 top-full pt-4 w-64 transition-all duration-300 ${compOpen ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 -translate-y-2 pointer-events-none"}`}>
                <div className="border border-white/10 bg-[#0d0d0d] p-2">
                  {COMPANY_MENU.map((c) => (
                    <Link key={c.to} to={c.to} className="block px-3 py-2.5 hover:bg-white/5 transition-colors group">
                      <div className="font-display text-sm font-semibold text-white group-hover:text-[#c3e63c] transition-colors">{c.label}</div>
                      <div className="text-xs text-neutral-500 mt-0.5">{c.desc}</div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              className="hidden sm:inline-flex btn-accent items-center gap-2 border border-[#c3e63c]/70 px-4 py-2.5 eyebrow text-[#c3e63c] hover:bg-[#c3e63c] hover:text-[#0a0a0a]"
            >
              Contact <ArrowUpRight size={14} />
            </Link>
            <button className="xl:hidden text-white p-1" onClick={() => setOpen((v) => !v)} aria-label="Menu">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`xl:hidden overflow-hidden bg-[#0a0a0a] border-b border-white/10 transition-[max-height] duration-500 ${open ? "max-h-[520px]" : "max-h-0"}`}>
        <div className="px-5 py-5 flex flex-col gap-1">
          {NAV_LINKS.concat([{ label: "Contact", to: "/contact" }]).map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"}
              className={({ isActive }) => `eyebrow py-3 border-b border-white/5 ${isActive ? "text-[#c3e63c]" : "text-neutral-300"}`}>
              {l.label}
            </NavLink>
          ))}
          <div className="mt-4 inline-block bg-[#c3e63c] px-3 py-1.5 font-display font-bold uppercase tracking-[0.08em] text-[#0a0a0a] text-xs">Its a Garry Industries venture for railways projects!</div>
        </div>
      </div>
    </header>
  );
}
